import { initialChannelState, IChannelState } from '../state/channel.state';
import { ChannelsActions, EChannelsActions } from '../actions/channels.actions';

export const channelsReducers = (
    state = initialChannelState,
    action: ChannelsActions
  ): IChannelState => {
    switch (action.type) {
      case EChannelsActions.GetChannelsSuccess: {
        return {
          ...state,
          channels: action.payload
        };
      }
      case EChannelsActions.GetChangeChannel: {
        return {
          ...state,
          changeChannel: action.payload
        };
      }
      default:
        return state;
    }
  };
